import React from "react";
export const UserContext = React.createContext({
    user: null,
    setUser: ()=>null
});
const refEquality = (a, b)=>a === b;
export function useUserContext(selector, equalityFn = refEquality) {
    const state = React.useContext(UserContext);
    if (state === null) {
        throw new Error("useUserContext must be used within an UserContextProvider");
    }
    const selectedState = selector(state);
    const selectedStateRef = React.useRef(selectedState);
    const latestSelectedState = selectedStateRef.current;
    if (!equalityFn(latestSelectedState, selectedState)) {
        selectedStateRef.current = selectedState;
    }
    return selectedStateRef.current;
}
